import ISnackbarState from "../ISnackbarState";

const InitialSnackbarState: ISnackbarState = {
    type: "success",
    isOpen: false,
    message: "",
};

export default InitialSnackbarState;
